import script from "./security-alert.vue?vue&type=script&setup=true&lang=js"
export * from "./security-alert.vue?vue&type=script&setup=true&lang=js"

import "./security-alert.vue?vue&type=style&index=0&id=402f3b30&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402f3b30"]])

export default __exports__